import CryptoJSCore from 'crypto-js/core';
import SHA1 from 'crypto-js/sha1';
import hasIn from 'lodash/hasIn';
import { call, select } from 'redux-saga/effects';

import * as D from './deps';

const log = D.Logger.child({ component: 'comscore/utils' });

/**
 * Gets SHA1 encrypted listenerId
 *
 * @returns {string} SHA1 encrypted listenerId
 */
export function* getCsXi() {
  if (yield select(D.Utils.Listener.isAnonymousListener)) {
    return log.info('getCsXi(): anonymous user detected');
  }

  const currentListenerId = yield select(D.Utils.Listener.getCurrentListenerIdFromState);
  return SHA1(currentListenerId).toString(CryptoJSCore.enc.Base64);
}

/**
 * Build and return string containing listener age and gender
 *
 * @returns {string} concatenated string of listener age and gender
 */
export function* getCsWn() {
  if (yield select(D.Utils.Listener.isAnonymousListener)) {
    return log.info('getCsWn(): anonymous user detected');
  }

  const genderCodeEnums = {
    MALE: 1,
    FEMALE: 2,
    '': 0,
  };

  const year = parseInt(yield select(D.Utils.Listener.getCurrentUserBirthYear), 10) + 1999;
  const gender = genderCodeEnums[yield select(D.Utils.Listener.getCurrentUserGender)];

  return `u${year}z${gender}`;
}

export function* get1pParams() {
  const genderCodeEnums = {
    UNSPECIFIED: 0,
    MALE: 1,
    FEMALE: 2,
    NON_BINARY: 3,
  };

  const isAnonymousListener = yield select(D.Utils.Listener.isAnonymousListener);
  const gender = genderCodeEnums[yield select(D.Utils.Listener.getCurrentUserGender)];
  const birthYear = parseInt(yield select(D.Utils.Listener.getCurrentUserBirthYear), 10);
  const age = new Date().getFullYear() - birthYear;
  const underage = age < 18;

  return {
    cs_fpid: yield select(D.Utils.Listener.getListenerPublicLid),
    cs_fpit: 'li',
    cs_fpdm: isAnonymousListener || !birthYear || underage ? '*null' : getDemographicsData(),
    cs_fpdt: '01',
  };

  function getDemographicsData() {
    return parseInt(getAgeGroup() + gender, 10) + 19991999999;
  }

  function getAgeGroup() {
    if (age > 64) {
      return '12';
    } else if (age > 54) {
      return '11';
    } else if (age > 44) {
      return '10';
    } else if (age > 34) {
      return '09';
    } else if (age > 24) {
      return '08';
    } else if (age > 20) {
      return '07';
    } else if (age > 17) {
      return '06';
    }
    return '00';
  }
}

/**
 * Call Comscore beacon
 *
 * @param  {object} params - QueryString params to apply to beacon call
 * @returns {null}     [description]
 */
// eslint-disable-next-line require-yield
export function* pingComscore(params = {}) {
  if (!hasIn(window, 'COMSCORE.beacon')) {
    return log.info('pingComscore(): COMSCORE not loaded');
  }
  const demographicsParams = yield call(get1pParams);
  // default
  const extendedParams = Object.assign(
    {},
    {
      c1: 2,
      c2: '6036333',
      c3: '',
      c4: '',
      c5: '',
      c6: '',
      c15: '',
      ...demographicsParams,
    },
    params,
  );

  log.info('pingComscore(): pinging');

  window.COMSCORE.beacon(extendedParams);
}
